import { render } from "./Label.vue?vue&type=template&id=5503eafc"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import "./Label.vue?vue&type=style&index=0&id=5503eafc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5503eafc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5503eafc', __exports__)) {
    api.reload('5503eafc', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=5503eafc", () => {
    api.rerender('5503eafc', render)
  })

}


export default __exports__